import { useQuery } from '@tanstack/react-query';
import { getStoreGames } from 'services/scratcherService';
import GameListModel, { GameListData } from 'models/scratcher/GameListModel';

export function useStoreGames(storeId?: string) {
    const queryResult = useQuery<GameListModel, Error>({
        queryKey: ['store-games', storeId],
        queryFn: async () => {
            if (!storeId) {
                return GameListModel.createEmpty();
            }

            const response = await getStoreGames(storeId);
            if (response.success && response.data) {
                return GameListModel.fromServerData(response.data);
            }

            throw new Error(response.error || 'Failed to load store games');
        },
        enabled: Boolean(storeId),
        staleTime: 5 * 60 * 1000, // Games list probably doesn't change often
    });

    const gameListModel = queryResult.data ?? GameListModel.createEmpty();

    return {
        gameList: gameListModel.games,
        isLoading: queryResult.isLoading,
        isError: queryResult.isError,
        error: queryResult.error ?? null,
    };
}
